const LoadingException=(props)=>{
    const handleClick = (params) => {
        props.onShowLoadingData(props);
    };
    let color = "#cccc"
    if (props.getValue() != undefined && props.getValue() == 1) {
        color = "#d3a337"
    }
    return(
        <a onClick={handleClick}  title="Loading Exception"><i className="icofont icofont-truck-alt f20" style={{ color: color }}></i> </a>
    )
}
export default LoadingException